import React, { Component } from 'react'
import {
  BrowserRouter,
  Route,
  Redirect,
  Switch
} from 'react-router-dom'
import * as request from 'superagent'
import {
  auth,
  isAuthenticated,
  storageKey
} from './firebase'
import { API_BASE_URL } from './index'

import Login from './Public/Login/Login'
import Dash from './Private/Dash'

class App extends Component {
  constructor () {
    super()
    this.state = {
      uid: null,
      user: null
    }
  }

  componentDidMount () {
    auth.onAuthStateChanged(user => {
      // token based
      if (user) {
        window.localStorage.setItem(storageKey, user.uid)
        this.setState({ uid: user.uid })
        request
          .post(API_BASE_URL + '/getUser')
          .send({ uid: user.uid })
          .then(json => {
            if (json.ok) {
              const user = Object.assign({}, json.body.user, json.body.userInfo)
              this.setState({ user })
            } else {
              throw new Error('Network Error - no user')
            }
          })
          .catch(err => console.log(err))
      } else {
        window.localStorage.removeItem(storageKey)
        this.setState({ uid: null, user: null })
      }
    })
  }

  render () {
    return (
      <BrowserRouter>
        <Switch>
          <Route path='/login' render={
            () => <Login />
          }
          />
          <Private path='/dash' component={Dash}
            passThrough={{
              user: this.state.user
            }}
          />
          <Route render={
            () => <Redirect to='/login' />
          } />
        </Switch>
      </BrowserRouter>
    )
  }
}

const Private = ({ component: Component, passThrough, ...rest }) => (
  <Route {...rest} render={renderProps => (
    isAuthenticated() ? (
      <Component {...renderProps} {...passThrough} />
    ) : (
      <Redirect to={{
        pathname: '/login'
      }} />
    )
  )} />
)

export default App



// WEBPACK FOOTER //
// ./src/App.js